export default {
  methods: {
    JsonFieldToDisplay() {
      if (this.mode == 1) {
        return this.usage.DISPLAY_ANSWER_TEXT;
      }
      if (this.selectedLanguageCulture === "EN") {
        return this.usage.ANSWER_TEXT;
      } else {
        return this.usage.DISPLAY_ANSWER_TEXT;
      }
    }
  },
  computed: {
    stepNo() {
      if (this.activityType == "activity") {
        return this.question.stepSequence || this.question.sequence;
      } else {
        return this.stepIndex + 1;
      }
    },
    showScore() {
      if (this.answer && (!this.answer.isDisabled || this.answer.isDisabled == undefined) && this.surveyData && this.surveyData.canScoreResponses) {
        return true;
      } else {
        return false;
      }
    }
  }
};
